<template>
  <div class="twui-markbox xsearch xsearch-padding">
    <div class="search">
      <span class="search-result">
        <span class="xkeywords">{{oldSearchKey}}</span>
        {{$t('m.common')}}{{documentList.length}}{{$t('m.ssjg')}}
      </span>
      <div class="searchbox">
        <el-input @keyup.enter.native="searchDoc" v-model="$store.state.searchKey" :placeholder="$t('m.input_key')"></el-input>
        <i class="twui-ico xsearch" @click="searchDoc"></i>
      </div>
    </div>

    <div class="search-result-box">
      <div v-if="hasData">
        <div class="item" v-for="(item,index) in documentList" :key="index">
          <a class="xtit" @click="goToDoc(item.docId)" v-html="item.titleHtml"></a>
          <p class="xcont">{{item.content}}</p>
        </div>
      </div>
      <!--暂无数据-->
      <div class="nodata-box" v-if="!hasData">
        <img src="/static/dev/images/nodata.png" alt />
        <span>{{$t('m.mycxdjl')}}</span>
      </div>
      <!--/暂无数据-->
    </div>
  </div>
</template>

<script>
import utils from '@/config/cookieUtils'
export default {
  name: 'twMarkdown',
  data: function () {
    return {
      documentList: [],
      searchKey: '',
      oldSearchKey: '',
      title: '这是标题',
      date: '更新时间：2018-08-13 14:15:02',
      hasData: false // 只进行样式说明
    }
  },
  methods: {
    goToDoc: function (docId) {
      this.getMenuList(docId)
    },
    getMenuList (menuId) {
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', {
          lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
          menuId: menuId
        })
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            this.$store.commit('changePageName', 'Doc')
            this.$store.commit('changeMenuList2th', [])
            this.$store.commit('changeMenuList3th', [])
            this.$store.commit('changeTypeOfAppList', [])
            this.$store.commit('changeMenuId', menuId)
            utils.set('nowMenuId', menuId)
          } else {
            this.$message.error(res.data.serverResult.resultMessage)
          }
        })
    },
    searchDoc: function () {
      let vm = this
      let req = {}
      let searchKey = this.$store.state.searchKey
      if (typeof searchKey === 'string' && searchKey.constructor === String) {
        req.searchKey = searchKey
      } else {
        req.searchKey = this.$store.searchKey
      }
      req.ifToText = '1'
      vm.axios
        .post('/openapi-uc/doc/searchDocumentView', req)
        .then(function (response) {
          vm.oldSearchKey = req.searchKey
          if (
            response.data.pageInfo &&
            response.data.pageInfo.list &&
            response.data.pageInfo.list.length > 0
          ) {
            vm.documentList = response.data.pageInfo.list
            vm.hasData = true
            for (let a in vm.documentList) {
              let list = vm.documentList
              if (list[a].content) {
                list[a].content = list[a].content.replace(/[/n]/g, '')
              }
              let replaceReg = new RegExp(vm.oldSearchKey, 'g') // 匹配关键字正则
              let replaceString =
                "<span style='color:red'>" + vm.oldSearchKey + '</span>' // 高亮替换v-html值
              vm.documentList[a].titleHtml = list[a].docTitle.replace(replaceReg, replaceString) // 开始替换
            }
          } else {
            vm.documentList = []
            vm.hasData = false
          }
        })
    }
  },
  watch: {},
  mounted: function () {
    let vm = this
    vm.searchDoc(vm.$store.state.searchKey)
  },
  created: function () {}
}
</script>
<style scoped>
.xsearch-padding {
  padding: 0 10%;
}
.highlights-text {
  color: #ff5134;
}
</style>


// WEBPACK FOOTER //
// search.vue?78e6dab8